export const API_PATH_ApiWorkzonesManagementOfflineImportPost = '/services/workzones-management/offline-import';
export var EOfflineAction;
(function (EOfflineAction) {
    EOfflineAction["CREATE"] = "CREATE";
    EOfflineAction["UPDATE"] = "UPDATE";
    EOfflineAction["DELETE"] = "DELETE";
    EOfflineAction["UNDELETE"] = "UNDELETE";
    EOfflineAction["PERMANENT_DELETE"] = "PERMANENT_DELETE";
})(EOfflineAction || (EOfflineAction = {}));
